<template>
  <div class="download">
    <a @click="downloadInstall()" :href="`${apkUrl}`">立即体验 · 免费下载</a>
  </div>
</template>

<script>
  import utils from '../utils/utils'
  export default {
    name: 'Download',
    components: {},
    setup () {
      let env = window.env
      let apkUrl = `/apks/${env.version}/${env.app}-${env.version}-release-${env.channel}.apk`
      function downloadInstall () {
        utils.statsDownload()
      }
      return {
        downloadInstall,
        apkUrl,
        env
      }
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
  }

  .download {
    font-weight: 700;
    font-size: 1.2rem;
  }

  .download a {
    display: inline-block;
    color: #000000;
    padding: 1rem 3rem;
    border: none;
    border-radius: 50px;
    background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
    box-shadow: 0 8px 24px rgba(255,215,0,0.4);
    transition: all 0.3s ease;
    font-weight: 700;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .download a::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s ease;
  }

  .download a:hover::before {
    left: 100%;
  }

  .download a:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(255,215,0,0.5);
    background: linear-gradient(135deg, #ffed4e 0%, #ffd700 100%);
  }

  .download a:active {
    transform: translateY(-1px);
  }

  @media all and (max-width: 799px) {
    .download a {
      padding: 0.9rem 2.5rem;
      font-size: 1.1rem;
    }
  }
</style>
